import { Input } from '@/components/ui/input';

export interface DateInputProps {
  value: {
    year: string;
    month: string;
    day: string;
  };
  onChange: (value: { year: string; month: string; day: string }) => void;
  isHijri: boolean;
}


export function DateInput({ value, onChange, isHijri }: DateInputProps) {
  const handleChange = (field: 'year' | 'month' | 'day', inputValue: string) => {
    let numValue = inputValue.replace(/\D/g, '');

    if (field === 'year') {
      // Prevent year from starting with 0
      if (numValue.startsWith('0')) {
        numValue = numValue.replace(/^0+/, '');
      }
    } else if (field === 'month' || field === 'day') {
      // Always allow single digits (1-9)
      if (numValue.length === 1) {
        onChange({ ...value, [field]: numValue });
        return;
      }
      
      // For two digits, validate the range
      if (numValue.length === 2) {
        const num = parseInt(numValue);
        if (field === 'month' && num > 12) {
          numValue = '12';
        } else if (field === 'day' && num > 31) {
          numValue = '31';
        }
      }
      
      // Clear if '00' is entered
      if (numValue === '00') {
        numValue = '';
      }
    }

    onChange({ ...value, [field]: numValue });
  };

  return (
    <div className="flex gap-2">
      <Input
        placeholder="السنة"
        value={value.year}
        onChange={(e) => handleChange('year', e.target.value)}
        maxLength={4}
        className="text-center"
      />
      <Input
        placeholder="الشهر"
        value={value.month}
        onChange={(e) => handleChange('month', e.target.value)}
        maxLength={2}
        className="text-center"
      />
      <Input
        placeholder="اليوم"
        value={value.day}
        onChange={(e) => handleChange('day', e.target.value)}
        maxLength={2}
        className="text-center"
      />
    </div>
  );
}